import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ValidateEventCodeMutationVariables = Types.Exact<{
  input: Types.ValidateEventCodeInput;
}>;

export type ValidateEventCodeMutation = {
  __typename?: 'Mutation';
  validateEventCode: {
    __typename?: 'ValidateEventCodeResponse';
    isValid: boolean;
  };
};

export const ValidateEventCodeDocument = gql`
  mutation ValidateEventCode($input: ValidateEventCodeInput!) {
    validateEventCode(input: $input) {
      isValid
    }
  }
`;
export type ValidateEventCodeMutationFn = Apollo.MutationFunction<
  ValidateEventCodeMutation,
  ValidateEventCodeMutationVariables
>;
export function useValidateEventCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateEventCodeMutation,
    ValidateEventCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateEventCodeMutation,
    ValidateEventCodeMutationVariables
  >(ValidateEventCodeDocument, options);
}
export type ValidateEventCodeMutationHookResult = ReturnType<
  typeof useValidateEventCodeMutation
>;
export type ValidateEventCodeMutationResult =
  Apollo.MutationResult<ValidateEventCodeMutation>;
export type ValidateEventCodeMutationOptions = Apollo.BaseMutationOptions<
  ValidateEventCodeMutation,
  ValidateEventCodeMutationVariables
>;
